module.exports = __webpack_public_path__ + "img/qr.ad4144e8.svg";